import * as Types from '../../types/graphql.gen';

import { gql } from '@apollo/client';
export type PatientUnitFragment = { __typename?: 'Patient', id: string, mainUser: boolean, idDocumentRegistered: boolean, selectedMyNumberCard: boolean, patientIdCardNumber?: string | null, shouldRegisterIdCard?: boolean, orcaConnected?: boolean, claimantCertification: { __typename?: 'IdDocument', documentType: Types.IdDocumentKind, image: string, registeredAt: string, id: string, confirmedAt: string } | null, insuranceCard: { __typename?: 'IdDocument', documentType: Types.IdDocumentKind, image: string, registeredAt: string, id: string, confirmedAt: string } | null, profile: { __typename?: 'Profile', avatar: string | null, id: string, birthday: string | null, building: string | null, city: string | null, district: string | null, firstname: string | null, firstnameJ: string | null, gender: Types.Gender | null, lastname: string | null, lastnameJ: string | null, name: string | null, nameJ: string | null, phone: string | null, postal: string | null, prefecture: string | null, lat: number | null, lng: number | null } | null };

export type ProfileUnitFragment = { __typename?: 'Profile', avatar: string | null, id: string, birthday: string | null, building: string | null, city: string | null, district: string | null, firstname: string | null, firstnameJ: string | null, gender: Types.Gender | null, lastname: string | null, lastnameJ: string | null, name: string | null, nameJ: string | null, phone: string | null, postal: string | null, prefecture: string | null, lat: number | null, lng: number | null };

export type BaseProfileUnitFragment = { __typename?: 'Profile', id: string, birthday: string | null, building: string | null, city: string | null, district: string | null, firstname: string | null, firstnameJ: string | null, gender: Types.Gender | null, lastname: string | null, lastnameJ: string | null, name: string | null, nameJ: string | null, phone: string | null, postal: string | null, prefecture: string | null, lat: number | null, lng: number | null };

export type IdDocumentUnitFragment = { __typename?: 'IdDocument', documentType: Types.IdDocumentKind, image: string, registeredAt: string, id: string, confirmedAt: string };

export const IdDocumentUnitFragmentDoc = gql`
    fragment IdDocumentUnit on IdDocument {
  documentType
  image
  registeredAt
  id
  confirmedAt
}
    `;
export const BaseProfileUnitFragmentDoc = gql`
    fragment BaseProfileUnit on Profile {
  id
  birthday
  building
  city
  district
  firstname
  firstnameJ
  gender
  lastname
  lastnameJ
  name
  nameJ
  phone
  postal
  prefecture
  lat
  lng
}
    `;
export const ProfileUnitFragmentDoc = gql`
    fragment ProfileUnit on Profile {
  avatar
  ...BaseProfileUnit
}
    ${BaseProfileUnitFragmentDoc}`;
export const PatientUnitFragmentDoc = gql`
    fragment PatientUnit on Patient {
  id
  mainUser
  claimantCertification: latestIdDocument(idDocumentType: ClaimantCertification) {
    ...IdDocumentUnit
  }
  insuranceCard: latestIdDocument(idDocumentType: InsuranceCard) {
    ...IdDocumentUnit
  }
  profile {
    ...ProfileUnit
  }
  idDocumentRegistered
  selectedMyNumberCard
  patientIdCardNumber(clinicId: $clinicId) @include(if: $withClinicId)
  shouldRegisterIdCard(clinicId: $clinicId) @include(if: $withClinicId)
  orcaConnected(clinicId: $clinicId) @include(if: $withClinicId)
}
    ${IdDocumentUnitFragmentDoc}
${ProfileUnitFragmentDoc}`;